// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"533":"9f4ed19f","842":"ef65a406"}[chunkId] + ".css";
};